import api from "@/lib/api";

const SW_URL = "/sw.js?v=5";

const toBytes = (v) => {
  const raw = atob((v + "=".repeat((4 - (v.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () => typeof window !== "undefined" && window.isSecureContext && "serviceWorker" in navigator && "PushManager" in window && typeof Notification !== "undefined";

export const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export function registerServiceWorker() {
  if ("serviceWorker" in navigator) navigator.serviceWorker.register(SW_URL, { updateViaCache: "none" }).then((r) => r.update()).catch(() => {});
}

export async function getPushSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return reg ? reg.pushManager.getSubscription() : null;
}

/** Must be called from a user tap (iOS requirement). */
export async function enablePush() {
  if (!pushSupported()) {
    throw new Error(isIos() && !isStandalone() ? "Na iPhoneu: Safari → Podijeli → Dodaj na početni zaslon, pa otvori Lodgy s početnog zaslona." : "Ovaj preglednik ne podržava push obavijesti.");
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Obavijesti nisu dopuštene u pregledniku.");
  const reg = await navigator.serviceWorker.register(SW_URL, { updateViaCache: "none" });
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  if (!data.publicKey) throw new Error("Push obavijesti nisu konfigurirane na serveru.");
  const key = toBytes(data.publicKey);
  let sub = await reg.pushManager.getSubscription();
  if (sub && !sameKey(sub.options?.applicationServerKey, key)) { await sub.unsubscribe(); sub = null; }
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
  await api.post("/push/subscribe", sub.toJSON());
  return sub;
}

const sameKey = (buf, key) => {
  if (!buf) return true;
  const a = new Uint8Array(buf);
  return a.length === key.length && a.every((v, i) => v === key[i]);
};

/** Re-registers an existing device subscription with the server (silent, on app load). */
export async function syncPush() {
  try {
    if (!pushSupported() || Notification.permission !== "granted") return;
    if (await getPushSubscription()) await enablePush();
  } catch (_) { /* silent */ }
}

export async function disablePush() {
  const sub = await getPushSubscription();
  if (!sub) return;
  await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
  await sub.unsubscribe();
}
